import maskVue from './index.vue'

const maskComponent = {}

maskComponent.install = function (Vue, option) {
  const MaskInstance = Vue.extend(maskVue)
  let mask
  const initInstance = () => {
    mask = new MaskInstance()
    const maskDom = mask.$mount().$el
    document.body.appendChild(maskDom)
  }
  window.$cusMask = Vue.prototype.$cusMask = {
    /** 显示遮罩的方法 */
    show(callback) {
      initInstance()
      if (typeof callback === 'function') {
        Object.assign(mask, { isShow: true, maskClick: callback })
      } else {
        Object.assign(mask, { isShow: true })
      }
    },
    /** 隐藏遮罩的方法 */
    hide() {
      if (mask) {
        Object.assign(mask, { isShow: false })
      }
    },
    /** 获取当前遮罩的状态 */
    getMaskIsShow() {
      if (mask == undefined) {
        return false
      }
      return mask.isShow
    },
  }
}

export default maskComponent
